module.exports = __webpack_public_path__ + "img/image02.68a54878.jpg";